module.exports = __webpack_public_path__ + "static/media/5.c189a3c4.png";